import React, { useState } from "react";
import Copy from "./../../agenzLogos/Copy";
import Facebook from "./../../agenzLogos/FBcircle";
import Linkedin from "./../../agenzLogos/INcircle";
import Whatsapp from "./../../agenzLogos/Whatsapp";
import style from "./Share.module.css";
import formatUrl from "utils/FormatUrl";

function Share({ setShowShare, linkToShare, t, message, lang }) {
  const linkToShareFormatted = `https://agenz.ma/${formatUrl(
    linkToShare,
    lang
  )}`;
  const handleParentClick = (event) => {
    event.preventDefault();

    if (event.target === event.currentTarget) {
      setShowShare(false);
    }
  };

  const [copied, setCopied] = useState<boolean>(false);

  const FBLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(
    linkToShareFormatted.trim().replace(/ /g, "-")
  )}&quote=${t(message)}`;

  const WhatsappLink = `https://wa.me?text=${`${t(message)} : ${encodeURI(
    linkToShareFormatted.trim().replace(/ /g, "-")
  )}`}`;

  const LinkedInLink = `https://www.linkedin.com/shareArticle?mini=true&url=${linkToShareFormatted}&summary=${t(
    message
  )}`;

  const copyToClipboard = () => {
    var textField = document.createElement("textarea");
    textField.innerText = linkToShareFormatted;
    document.body.appendChild(textField);
    textField.select();
    textField.setSelectionRange(0, 99999); // For mobile devices
    navigator.clipboard.writeText(textField.value);
    setCopied(true);
    textField.remove();
  };

  setTimeout(() => {
    if (copied) setCopied(false);
  }, 3000);

  const openLink = (Link) => {
    window.open(Link, "_blank", "noreferrer nofollow noopener");
  };

  return (
    <div className={style.modalContainer} onClick={handleParentClick}>
      <div className={style.modal}>
        <div
          className={style.xClose}
          onClick={() => {
            setShowShare(false);
          }}
        >
          <div></div>
          <div></div>
        </div>
        <p>{t("Partager sur")}...</p>
        <div>
          <a
            href={FBLink}
            target="_blank"
            onClick={() => {
              openLink(FBLink);
            }}
          >
            <Facebook />
            {t("Facebook")}
          </a>
          <a
            href={LinkedInLink}
            target="_blank"
            onClick={() => {
              openLink(LinkedInLink);
            }}
          >
            <Linkedin />
            {t("LinkedIn")}
          </a>
          <a
            href={WhatsappLink}
            target="_blank"
            onClick={() => {
              openLink(WhatsappLink);
            }}
          >
            <Whatsapp />
            {t("Whatsapp")}
          </a>
          <span onClick={copyToClipboard} style={{ cursor: "pointer" }}>
            <Copy />
            {copied ? t("Copié") : t("Copier le lien")}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Share;
